module.exports = __webpack_public_path__ + "resources/img/img_main_bnr_ahnlab_marketplace_m.841242eaafd290986114246e25cfa2b3.png";